class CartIcon extends HTMLElement {
  constructor() {
    super();
    this.cartDrawer = document.querySelector('cart-drawer')

    this.addEventListener('click', (e) => {
      e.preventDefault()
      this.openDrawer()
    });
  }

  openDrawer() {
    if (window.location.pathname != '/cart') {
      document.querySelector('cart-drawer').setAttribute('open', 'true')

      document.querySelector('body').classList.add('cart-opened')
      document.querySelector('html').classList.add('cart-opened')

      // this.cartDrawer.calcHeight()
    }
  }
  forceDrawer() {
    if (window.location.pathname != '/cart') {
      document.querySelector('cart-drawer').setAttribute('open', 'force')

      document.querySelector('body').classList.add('cart-opened')
      document.querySelector('html').classList.add('cart-opened')
    }
  }
}
customElements.define('cart-icon', CartIcon);
